import React from "react";

export default function FormSpinner(props) {
  return (
    <div className="inline-block mx-4">
      <div 
        className="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"
        style={{
          animationDuration: "550ms"
        }}
        {...props}
      />
    </div>
  );
}
